import React, { useState, useEffect } from 'react';
import { getMyMarks } from '../../api';
import { toast } from 'react-toastify';

const StudentMarks = () => {
  const [marks, setMarks] = useState([]);

  useEffect(() => { loadMarks(); }, []);

  const loadMarks = async () => {
    try {
      const res = await getMyMarks();
      setMarks(res.data);
    } catch (err) {
      toast.error('Error loading marks');
    }
  };

  const getGrade = (percentage) => {
    if (percentage >= 90) return { grade: 'A+', color: '#155724', bg: '#d4edda' };
    if (percentage >= 80) return { grade: 'A', color: '#155724', bg: '#d4edda' };
    if (percentage >= 70) return { grade: 'B', color: '#004085', bg: '#cce5ff' };
    if (percentage >= 60) return { grade: 'C', color: '#856404', bg: '#fff3cd' };
    if (percentage >= 50) return { grade: 'D', color: '#856404', bg: '#fff3cd' };
    return { grade: 'F', color: '#721c24', bg: '#f8d7da' };
  };

  const subjectWise = marks.reduce((acc, m) => {
    if (!acc[m.subject_name]) acc[m.subject_name] = [];
    acc[m.subject_name].push(m);
    return acc;
  }, {});

  return (
    <div>
      <h3 style={styles.title}>📊 My Marks</h3>

      {Object.entries(subjectWise).map(([subject, subjectMarks]) => {
        const totalObtained = subjectMarks.reduce((s, m) => s + parseFloat(m.obtained_marks || 0), 0);
        const totalPossible = subjectMarks.reduce((s, m) => s + parseFloat(m.total_marks || 0), 0);
        const overallPct = totalPossible > 0 ? ((totalObtained/totalPossible)*100).toFixed(1) : 0;
        const gradeInfo = getGrade(overallPct);

        return (
          <div key={subject} style={styles.subjectCard}>
            <div style={styles.subjectHeader}>
              <h4 style={styles.subjectName}>{subject}</h4>
              <div style={styles.overallBadge}>
                <span style={styles.overallPct}>{overallPct}%</span>
                <span style={{
                  ...styles.gradeBadge,
                  background: gradeInfo.bg,
                  color: gradeInfo.color
                }}>{gradeInfo.grade}</span>
              </div>
            </div>

            <table style={styles.table}>
              <thead>
                <tr style={styles.tableHeader}>
                  <th style={styles.th}>Exam Type</th>
                  <th style={styles.th}>Obtained</th>
                  <th style={styles.th}>Total</th>
                  <th style={styles.th}>Percentage</th>
                  <th style={styles.th}>Grade</th>
                  <th style={styles.th}>Remarks</th>
                </tr>
              </thead>
              <tbody>
                {subjectMarks.map(m => {
                  const pct = ((m.obtained_marks/m.total_marks)*100).toFixed(1);
                  const g = getGrade(pct);
                  return (
                    <tr key={m.id} style={styles.tableRow}>
                      <td style={styles.td}>
                        <span style={styles.typeBadge}>{m.exam_type}</span>
                      </td>
                      <td style={styles.td}>{m.obtained_marks}</td>
                      <td style={styles.td}>{m.total_marks}</td>
                      <td style={styles.td}>
                        <div style={styles.progressBar}>
                          <div style={{
                            ...styles.progressFill,
                            width: `${pct}%`,
                            background: pct >= 60 ? '#28a745' : '#dc3545'
                          }} />
                          <span style={styles.progressText}>{pct}%</span>
                        </div>
                      </td>
                      <td style={styles.td}>
                        <span style={{
                          ...styles.gradeBadge,
                          background: g.bg,
                          color: g.color
                        }}>{g.grade}</span>
                      </td>
                      <td style={styles.td}>{m.remarks || '-'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        );
      })}

      {marks.length === 0 && (
        <div style={styles.empty}>No marks uploaded yet!</div>
      )}
    </div>
  );
};

const styles = {
  title: { color: '#1a3a5c', marginBottom: '20px' },
  subjectCard: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  subjectHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px', paddingBottom: '10px', borderBottom: '2px solid #f0f0f0' },
  subjectName: { color: '#1a3a5c', margin: 0, fontSize: '16px' },
  overallBadge: { display: 'flex', alignItems: 'center', gap: '10px' },
  overallPct: { fontSize: '18px', fontWeight: 'bold', color: '#1a3a5c' },
  gradeBadge: { padding: '4px 12px', borderRadius: '20px', fontSize: '13px', fontWeight: 'bold' },
  table: { width: '100%', borderCollapse: 'collapse' },
  tableHeader: { background: '#f5f7fa' },
  th: { padding: '10px 12px', color: '#555', textAlign: 'left', fontSize: '13px', fontWeight: '600' },
  tableRow: { borderBottom: '1px solid #eee' },
  td: { padding: '10px 12px', fontSize: '13px', color: '#444' },
  typeBadge: { padding: '3px 10px', background: '#e8f0fe', color: '#1a3a5c', borderRadius: '20px', fontSize: '12px' },
  progressBar: { position: 'relative', background: '#e9ecef', borderRadius: '10px', height: '20px', width: '100px' },
  progressFill: { position: 'absolute', left: 0, top: 0, height: '100%', borderRadius: '10px' },
  progressText: { position: 'absolute', width: '100%', textAlign: 'center', fontSize: '11px', fontWeight: 'bold', color: 'white', lineHeight: '20px' },
  empty: { textAlign: 'center', color: '#999', padding: '40px', background: 'white', borderRadius: '12px' },
};

export default StudentMarks;